import { createRoot } from "react-dom/client";
import "@/lib/i18n";
import App from "./App.tsx";
import { RouteErrorBoundary } from "./components/RouteErrorBoundary";
import { shouldAttemptChunkRecovery } from "@/lib/chunk-recovery";
import "./index.css";

/**
 * After a deploy, the new bundle replaces every hashed chunk. A still-open tab holds the OLD
 * chunk URLs in memory and the next lazy navigation triggers Vite's `vite:preloadError`. Catch it
 * here (before React renders the error boundary fallback) and reload silently — once per pathname
 * per recovery window so a genuinely missing chunk does not become a reload loop.
 */
if (typeof window !== "undefined") {
  window.addEventListener("vite:preloadError", (event) => {
    if (!shouldAttemptChunkRecovery()) return;
    event.preventDefault();
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(
  <RouteErrorBoundary>
    <App />
  </RouteErrorBoundary>,
);
